<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container *ngIf="mode === 'nohomesmall' else mbfilters">
        {{zielText + ' Abfahrtsbahnhof'}}
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100 tmpnobottomborder" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="train"></mat-icon>
        <span multilang>{{zielText + ' Abfahrtsbahnhof'}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #homemodeMobile>
    <button class="tmpbtn tmpnorightborder w100 tmp-bottom-left" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="train"></mat-icon>
        <span multilang>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn tmpnorightborder w100" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <mat-icon fontIcon="train"></mat-icon>
        <span multilang>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" multilang deeplMode='placeholder' placeholder="Abfahrtsbahnhof hinzufügen"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus" class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" multilang deeplMode='placeholder' placeholder="Abfahrtsbahnhof hinzufügen"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <ng-container *ngIf="selectedList?.length > 0">
            <div class="selected-wrapper">
                <button class="selected-item-alle" (click)="removeAllSelected()">
                    <span multilang>Alles löschen</span>
                </button>
                <ng-container *ngFor="let item of selectedList; let k = index">
                    <div class="selected-item">
                        <span multilang>{{item.name}} <span multilang
                                class="second-item-line">{{item.code}}</span></span>
                        <button (click)="removeFromSelected(k)">
                            <mat-icon class="clearbtn">clear</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngFor="let item of (searchObj | async)">
            <ng-container *ngIf="isNotInlist(item)">
                <button class="item-wrapper" (click)="selectValue(item)">
                    <div class="item-body">
                        <span multilang class="first-item-line">{{item.name}} <span multilang
                                class="second-item-line">{{item.code}}</span></span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="take()">ÜBERNEHMEN</button>
    </div>
</ng-template>